import { Component, OnInit, AfterViewInit, ChangeDetectorRef, HostListener, inject } from "@angular/core";
import { NgClass } from "@angular/common";
import { RouterOutlet } from "@angular/router";
import { HeaderComponent } from "@app/core/layout/header/header.component";
import { NavigationComponent } from "@app/core/layout/navigation/navigation.component";
import { NavStateService } from "@app/core/layout/navigation/nav-state.service";
import { environment } from '@env/environment';
import { GlobalsService } from "@app/cp/shared/services/globals.service";
import { routerTransitions } from "@app/core/animations/router-transitions";
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { Router } from "@angular/router"; // <-- Add this import

@Component({
    selector: "app-main-layout",
    templateUrl: "./main-layout.component.html",
    styleUrls: ['./main-layout.component.scss'],
    animations: [routerTransitions],
    standalone: true,
    imports: [NgClass, RouterOutlet, HeaderComponent, NavigationComponent],
})
export class MainLayoutComponent implements OnInit, AfterViewInit {
    private readonly navState = inject(NavStateService);
    readonly navCollapsed = this.navState.collapsed;

    envType = environment.deployment;
    envBannerClass = this.getEnvBannerClass(environment.deployment);
    envVars = !environment.production;
    envApiLoc = environment.APIEndPoint;
    envApiCLoc = environment.APICEndPoint;
    public isBirthday: Boolean = false;
    public eventText: string = '';
    public eventSubText: string = '';
    public eventClass: string = '';
    public featureFlagSet: any = {};
    public isPopout: boolean = false;

    constructor(private globals: GlobalsService, private changeRef: ChangeDetectorRef, protected featureFlagService: FeatureFlagService, private router: Router) {
        this.featureFlagService.featureFlagSets.subscribe(data => {
            this.featureFlagSet = data;
        });
    }

    ngOnInit() {
        this.checkForEvent();
        this.isPopout = this.router.url.includes('/popout/');
        this.navState.collapseForMobile();
    }

    ngAfterViewInit() {
        this.changeRef.detectChanges();

    }

    @HostListener('window:resize')
    onWindowResize(): void {
        this.navState.collapseForMobile();
    }

    getEnvBannerClass(deployment: string): string {
        const normalizedDeployment = (deployment || '').toLowerCase();
        return normalizedDeployment.startsWith('rd') ? 'next' : normalizedDeployment;
    }

    getState(outlet) {
        if (!outlet.isActivated) {
            return null;
        }
        let ss = outlet.activatedRoute.snapshot;

        // return unique string that is used as state identifier in router animation
        return (
            outlet.activatedRouteData.state ||
            (ss.url.length ? ss.url[0].path : ss.parent.url.length ? ss.parent.url[0].path : null)
        );
    }

    checkForEvent() {
        //TODO BW: Expand to include other holidays
        if (localStorage.getItem("showEvent") != 'hide') {
            this.isBirthday = this.globals.user.isBirthday;
            if (this.isBirthday == true) {
                this.eventClass = 'birthday';
                this.eventText = 'Happy Birthday!';
                this.eventSubText = 'from Climate Pros to you';
                localStorage.setItem("showEvent", "show");
            }
        } else {
            this.isBirthday = false;
        }
    }

    closeEvent() {
        this.isBirthday = false;
        console.log(localStorage.getItem("showEvent"));
        localStorage.setItem("showEvent", "hide");
        console.log(localStorage.getItem("showEvent"));
    }

    public newGridStyles: any = false;
    checkForGridCSSFeatureFlag() {
        this.newGridStyles = this.featureFlagService.LdIsFeatureEnabled('kendo-grid-edit-template-css-change');
        console.log('newGridStyles', this.newGridStyles);
    }

}
